// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCORWk5UKI5A1u9fyldXZA-FFGVPgS9BK8",
  authDomain: "memory-stream-12e9d.firebaseapp.com",
  projectId: "memory-stream-12e9d",
  storageBucket: "memory-stream-12e9d.firebasestorage.app",
  messagingSenderId: "206204467703",
  appId: "1:206204467703:web:3be444a057f2a1248e56f2"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-central1');

// Connect to emulators in development
// Note: Emulators temporarily disabled due to Java PATH issue
// Uncomment when Firebase emulators are properly set up
if (false && process.env.NODE_ENV === 'development') {
  // Check if we're already connected to avoid multiple connections
  if (!auth.emulatorConfig) {
    connectAuthEmulator(auth, 'http://localhost:9099');
  }
  
  if (!db._delegate._databaseId?.database?.includes('emulator')) {
    connectFirestoreEmulator(db, 'localhost', 8080);
  }
  
  if (!storage._delegate._bucket?.includes('emulator')) {
    connectStorageEmulator(storage, 'localhost', 9199);
  }
  
  if (!functions.customDomain) {
    connectFunctionsEmulator(functions, 'localhost', 5001);
  }
}
